import { NavigationModal } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

type NoSafeguardingOfficerModalProps = {
  showModal: boolean
  handleModalClose: () => void
}

const NoSafeguardingOfficerModal = ({
  showModal,
  handleModalClose
}: NoSafeguardingOfficerModalProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <NavigationModal
      modalTitle={t('ASSIGN_AT_LEAST_1_SAF_OFFICERS')}
      modalConfirmText={t('CLOSE')}
      showPrompt={showModal}
      confirmNavigation={handleModalClose}
      cancelNavigation={handleModalClose}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <Text>
        <Trans
          i18nKey="EDIT_PERMISSIONS"
          ns={NAMESPACE.GENERAL}
          components={{
            team: (
              <StyledLink to={`${window.location.origin}/organisation/team`} />
            )
          }}
        />
      </Text>
      <Text weight="bold">{t('NOMINATE_TWO_SAF_OFFICERS')}</Text>
    </NavigationModal>
  )
}

export default NoSafeguardingOfficerModal

const StyledLink = styled(Link)`
  text-decoration: underline;
  color: ${(props) => props.theme.color.status.primary};
`
